import styled from 'styled-components'
import { GRAYSCALE_500, NEUTRAL_100, WHITE } from '@styles/colors'
import { safeAreaInset } from '@lib/telegram'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 12px 100px 12px;
  overflow-y: auto;
`

export const MerchantInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  padding: 16px 12px;
  gap: 16px;
`

export const OptionalText = styled.span`
  color: ${GRAYSCALE_500};
  text-align: center;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  left: 0;
  background-color: ${WHITE};
`

export const EmailWarningText = styled.span`
  font-family: ${INTER.regular};
  font-size: 12px;
  color: ${GRAYSCALE_500};
`